import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { ServiceBase } from './servicebase.service';

@Injectable({
  providedIn: 'root'
})
export class SearchService extends ServiceBase {

  public getSearchResults(searchParams: ServerModels.SearchParamsViewModel): Observable<ServerModels.SearchResultsViewModel[]> {
    let headersObj = this.httpOptions.headers.append('Skip-Loader', 'true');
    let paramsObj: HttpParams = new HttpParams({
      fromObject: <any>searchParams
    })
    let options = {
      headers: headersObj,
      params: paramsObj
    };
    return this.http.get<ServerModels.SearchResultsViewModel[]>(`${this.apiRoot}/api/Search/SearchResultsPaged`, options).pipe(catchError(this.throwError<any>('getSearchResults', 'ballisticEvidenceSearchMsg', 'Search failed:', null)));
  }

  public getballisticEvidenceListResults(searchParams: any): Observable<ServerModels.SearchResultsViewModel[]> {
    let headersObj = this.httpOptions.headers.append('Skip-Loader', 'true');
    let paramsObj: HttpParams = new HttpParams({
      fromObject: <any>searchParams
    })
    let options = {
      headers: headersObj
    };
    return this.http.post<ServerModels.SearchResultsViewModel[]>(`${this.apiRoot}/api/BallisticsEvidence/ListResultsViewPaged`, JSON.stringify(searchParams), options).pipe(catchError(this.throwError<any>('getballisticEvidenceListResults', 'ballisticEvidenceListMsg', 'Retrieve failed:', null)));
  }

}
